import script from "./ProgSocialEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgSocialEdit.vue?vue&type=script&setup=true&lang=js"

import "./ProgSocialEdit.vue?vue&type=style&index=0&id=a85100f8&lang=scss"

const __exports__ = script;

export default __exports__